module.exports = __webpack_public_path__ + "static/media/brochure.b3975bdd.png";